import { defineComponent as _defineComponent } from 'vue'
import TableauPopup from "../../ui-components/TableauPopup.vue";
import TableauLink from "../../ui-components/TableauLink.vue";
import TableauTextBox from "../../ui-components/TableauTextBox.vue";
import TableauRichTextBox from "../../ui-components/TableauRichTextBox.vue";
import TableauRadioGroup from "../../ui-components/TableauRadioGroup.vue";
import {
  ChangeRoleRequestDTO,
  ChangeRoleResponseDTO,
  SiteRoleType,
} from "../common/api/autogenerated";
import { computed, ref } from "vue";
import { container } from "tsyringe";
import { ApiModule } from "../common/api/api.module";
import { ChangeRoleCommonModule } from "./changerole-common.module";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeRolePopup',
  props: {
    info: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const possibleValues: { value: string; text: string; disabled?: boolean }[] = (
  props.info.availableRoles || []
).map((r: SiteRoleType) => {
  let normalizedName = "";
  for (let i = 0; i < r.length; i++) {
    if (r[i] === r[i].toUpperCase() && i != 0) {
      normalizedName += " ";
    }
    if (i === 0) {
      normalizedName += r[i].toUpperCase();
    } else {
      normalizedName += r[i];
    }
  }
  return { value: r, text: normalizedName, disabled: false };
});
const status = ref<"idle" | "loading" | "success" | "error">("idle");
const statusMessage = ref("The page will be refreshed");
const selectedRole = ref(props.info.currentRole);
const canSubmit = computed(
  () =>
    !!selectedRole.value &&
    selectedRole.value != props.info.currentRole &&
    (props.info.availableRoles || []).includes(selectedRole.value)
);
async function submit() {
  status.value = "loading";
  statusMessage.value = "The page will be refreshed";
  const apiModule = container.resolve(ApiModule);
  const changeRoleModule = container.resolve(ChangeRoleCommonModule);
  const api = await apiModule.apiRequest((c) =>
    c.apiChangeRoleTableauIntegrationChangeRole(
      new ChangeRoleRequestDTO({
        serverId: window.stm.config.serverId,
        requestedRole: selectedRole.value,
      })
    )
  );
  if (!api.success) {
    changeRoleModule.log.e("Failed to change role", api.error);
    status.value = "error";
    statusMessage.value = "Failed to change role";
  } else {
    status.value = "success";
    statusMessage.value = "Role changed. Refreshing page...";
    setTimeout(() => {
        let w: Window = window;
        if (w.parent) {
            w = w.parent;
        }
        try {
            reload(w);
        } catch (e) {
            try {
                reload(window);
            }catch(e) { }
        }

     
    }, 2000);
  }
}
function reload(window: Window) {
 if (
        selectedRole.value == SiteRoleType.Unlicensed &&
        window.location.href.includes("#")
      ) {
        window.location.href = window.location.href.substring(
          0,
          window.location.href.indexOf("#")
        );
      } else {
        window.location.reload();
      }
}

const __returned__ = { props, possibleValues, status, statusMessage, selectedRole, canSubmit, submit, reload, TableauPopup, TableauLink, TableauRadioGroup }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})